define('modules/start/products/email/activity/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        serialize: function() {
            return {
                "deliveries": this.productsReport.get("email_deliveries"),
                "opening_percent": this.productsReport.getEmailOpeningsPercent(),
                "clicks": this.productsReport.get("email_clicks"),
                "ctr": this.productsReport.getEmailCtr(),
                isAdm: this.isAdm
            };
        }
    });

    module.exports = Layout;
});

